'use client'

import { Button, Icon } from '@vinted/web-ui'
import { Stats16 } from '@vinted/monochrome-icons'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { clickEvent } from '@marketplace-web/vas/vas-data'

import { ITEM_URL } from '../../constants/routes'

type Props = {
  itemId: number
}

const PerformanceChartButton = ({ itemId }: Props) => {
  const { track } = useTracking()

  const handleOnClick = () => {
    track(
      clickEvent({
        target: 'show_item_performance',
        targetDetails: itemId.toString(),
        screen: 'current_user_profile',
      }),
    )
  }

  return (
    <Button
      icon={<Icon name={Stats16} color="parent" />}
      theme="primary"
      testId="bump-performance-button"
      size="small"
      url={ITEM_URL(itemId)}
      onClick={handleOnClick}
    />
  )
}

export default PerformanceChartButton
